<template>
    <div :class="groupClass">
        <div v-if="!hideLabel" :style="labelStyle" :class="themeLabelClass">
            <span>{{ label }}</span>
        </div>
        <div :style="valueStyle" :class="valueClass">
            <generic-field
                v-model="reactiveValue"
                v-bind="component"
            ></generic-field>
        </div>
    </div>
</template>

<script>
import GenericField from './GenericField';
export default {
    name: 'FieldGroup',
    components: {
        'generic-field': GenericField
    },
    props: {
        name: { type: String, required: true },
        label: { type: String, required: false, default: '' },
        component: {
            type: Object,
            required: false,
            default: () => {}
        },
        inline: { type: Boolean, default: false },
        value: {
            type: null,
            required: true
        },
        labelClass: {
            type: String,
            required: false,
            default: 'text-caption'
        },
        valueClass: {
            type: String,
            required: false,
            default: 'text-subtitle-1 font-weight-bold'
        },
        labelWidth: {
            type: String,
            required: false,
            default: '50%'
        },
        valueWidth: {
            type: String,
            required: false,
            default: '50%'
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        flexDirection() {
            if (this.inline) {
                return 'flex-row';
            }
            return 'flex-column';
        },
        groupClass() {
            const flex = 'd-flex';
            return `${flex} ${this.flexDirection}`;
        },
        labelStyle() {
            if (this.inline) {
                return `flex: 1 1 ${this.labelWidth}`;
            }
            return 'flex: 1 1 auto';
        },
        themeLabelClass() {
            let labelColor = 'deep-grey--text text--darken-1';
            if (this.$vuetify.theme.isDark) {
                labelColor = 'deep-grey--text text--lighten-1';
            }
            return `${this.labelClass} ${labelColor}`;
        },
        valueStyle() {
            if (this.inline) {
                return `flex: 1 1 ${this.valueWidth}`;
            }
            return 'flex: 1 1 auto';
        }
    }
};
</script>

<style></style>
